import { render } from "./R3SystemNotice.vue?vue&type=template&id=a8b935e2&scoped=true"
import script from "./R3SystemNotice.vue?vue&type=script&lang=js"
export * from "./R3SystemNotice.vue?vue&type=script&lang=js"

import "./R3SystemNotice.vue?vue&type=style&index=0&id=a8b935e2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b935e2"]])

export default __exports__